import React from 'react';
import { OrderTypeSummaryItemContainer } from './OrderTypeSummaryItemContainer';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';
import { IUpdateOrderPatchRequest } from '../../../../../../ui-toolkit/orders/interfaces/IUpdateOrderPatchRequest';
import { useUpdateOrderTimberHook } from '../../../../../../API/order/useUpdateOrderHook';

export const OrderType: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  const { action: doUpdateOrderTimberAction } = useUpdateOrderTimberHook();

  const onOrderGroupUpdate = async (updateData: Partial<IUpdateOrderPatchRequest>) => {
    await doUpdateOrderTimberAction(data, updateData);
  };
  return (
    <OrderTypeSummaryItemContainer label={'Order Type'} tab={`summary`} order={data} onUpdate={onOrderGroupUpdate} />
  );
};
